// extracted by mini-css-extract-plugin
export var legendIndicator = "_b7-1";
export var legendRight = "_b7-0";